import { apiClient } from "./api_base";

//Categories

export const addAffiliateCategory = async (inputData) => {
    const response = await apiClient.post('/categories/affiliate/create',{inputData});
    return response;
}

export const fetchCategories = async () => {
    const response = await apiClient.get('/categories');
    return response.data;
}

export const fetchCategoriesByAffiliate = async () => {
    const response = await apiClient.get('/categories/affiliate');
    return response.data;
}

export const fetchCategoryById = async (categoryId) => {
    const response = await apiClient.get(`/categories/affiliate/${categoryId}`);
    return response;
}

// Update an existing category for an affiliate
export const updateCategoryForAffiliate = async (categoryId, categoryData) => {
    const response = await apiClient.put(`/categories/affiliate/${categoryId}`, {
        image_url: categoryData.image_url,
    });
    return response.data;
};

// Delete a category for an affiliate
export const deleteCategoryForAffiliate = async (categoryId) => {
    const response = await apiClient.delete(`/categories/affiliate/${categoryId}`);
    return response.data;
}

// Fetch subcategories mapped from an affiliate category id
export const fetchSubcategoriesByAffiliateCategory = async (affiliateCategoryId) => {
    const response = await apiClient.get(`/categories/affiliate/${affiliateCategoryId}/subcategories`);
    return response;
}

// Fetch category averages
export const fetchParameterAveragesByCategory = async (categoryId, affiliateId) => {
    const response = await apiClient.get(`/averages/category/${categoryId}/affiliate/${affiliateId}`);
    return response;
}
